import React from "react";
import LGWashingPageTemplate from "./LGWashingPageTemplate";

const relatedLinks = [
  { to: "/lg-appliance-service-bangalore", label: "LG Appliance Service" },
  { to: "/lg-washing-machine-service-bangalore", label: "LG Washing Machine Service" },
  { to: "/lg-washing-machine-repair-bangalore", label: "LG Washing Machine Repair" },
  { to: "/lg-washing-machine-not-spinning", label: "LG Washing Machine Not Spinning" },
  { to: "/lg-washing-machine-water-leak-repair", label: "LG Washing Machine Water Leak Repair" },
];

const LGWashingMachineNotWorking = () => {
  return (
    <LGWashingPageTemplate
      title="LG Washing Machine Not Working Repair in Bangalore"
      description="LG washing machine not working repair in Bangalore for startup failures, electrical faults, and wash cycle problems."
      keywords="lg washing machine not working repair, lg washer not starting, lg repair bangalore"
      path="/lg-washing-machine-not-working-repair"
      bannerTitle="LG Washing Machine Not Working Repair"
      intro={<>If your <span style={{ fontWeight: 'bold' }}>LG washing machine is not working</span> or fully unresponsive, our Bangalore technicians can inspect the electrical supply, control board, door lock, and key components to restore normal operation.</>}
      highlights={[
        "Inspection for startup and power-on failures",
        "Control board, wiring, and switch diagnosis",
        "Door lock and safety sensor checks",
        "Doorstep repair support for LG washing machines",
      ]}
      issues={[
        "Machine not starting at all",
        "Buttons not responding",
        "Wash cycle not beginning",
        "Repeated shutdown during operation",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default LGWashingMachineNotWorking;
